module.exports = __webpack_public_path__ + "media/images/more-vertical-e214938c46b5fefa188504b48b83a5ad.svg";